// extracted by mini-css-extract-plugin
export default {"projectsMain":"ProjectsMain_projectsMain__8cwS8"};